import { render, staticRenderFns } from "./CoPaywall.vue?vue&type=template&id=36684e78&scoped=true&"
import script from "./CoPaywall.vue?vue&type=script&lang=ts&"
export * from "./CoPaywall.vue?vue&type=script&lang=ts&"
import style0 from "./CoPaywall.vue?vue&type=style&index=0&id=36684e78&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36684e78",
  null
  
)

export default component.exports